// Libs
import _filter from 'lodash/filter'
import _includes from 'lodash/includes'
import _reduce from 'lodash/reduce'
import { createSelector } from 'reselect'

// Selectors
import selectedJobId$ from 'hfty-map/src/selectors/selectedJobId'
import samplingPoints$ from './samplingPoints'
import { soilTestResults$ } from 'fc-soil-test-results'

export default createSelector(
  [
    selectedJobId$,
    samplingPoints$,
    soilTestResults$,
  ],
  (selectedJobId, samplingPoints, soilTestResults) => {
    if (!selectedJobId) {
      return null
    }
    const selectedPoints = _filter(samplingPoints, (point) => point.job === selectedJobId)
    return _reduce(selectedPoints, (acc, point) => {
      const soilTests = _filter(soilTestResults,
        (soilTest) => _includes(soilTest.soilSamplingPoints, point.id))
      acc.push({...point, soilTestResults: soilTests})
      return acc
    }, [])
  }
)
